import Canvastoimg from "wtc-canvastoimg";
import QRCode from 'qrcode'

Vue.component("usercardlight", {
  props: {
    my_all_info: Object,
  },
  template: `
  <div class="usercardlight" v-if="isShowUserCard&&cardInfo&&cardInfo.ui">
    <div class="usercard-container-n-light">
      <div class="usercard-container-normal-n">
        <div class="usercard-head-box">
          <div>
            <div class="usercard-company">
              {{company}}
              <img class="usercard-company-icon" mode="widthFix"
                src="https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/company.png" />
            </div>
            <div class="usercard-name">
              <div class="usercard-name-left">
                {{cardInfo.ui.name}}
              </div>
              <div v-if="roleName" class="usercard-name-line"></div>
              <div class="usercard-name-right">
                {{roleName}}
              </div>
            </div>
          </div>
          <div class="usercard-head" @click="handleEdit">
            <img :src="cardInfo.ui.headimg" />
            <div class="usercard-head-edit" v-if="isMyCard">
              <img src="https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/edit.png">
              <div>编辑</div>
            </div>
          </div>
        </div>
        <div class="usercard-intro" v-if="cardInfo.ui_personalprofile">
          <div>
            <img class="usercard-intro-icon" mode="widthFix"
              src="https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/quotation-marks.png" />
          </div>
          <div class="usercard-intro-txt">
            {{cardInfo.ui_personalprofile}}
          </div>
        </div>
        <div class="usercard-nav-box" :style="{marginTop:cardInfo.ui_personalprofile?'8px':'18px'}">
          <div class="usercard-nav" v-for="(item,index) in newNavData" :key="index" @click="clickItem(item)">
            <img class="nav-icon" :src="item.ico" />
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>


	  <!--  标准名片   -->
    <!--
		<div class="usercard-container-n" v-if="cardInfo && cardInfo.ui_cardtype == 1">
		  <div v-bind:class="[isDarker ? 'usercard-container-normal-n darker' : 'usercard-container-normal-n light']" v-bind:style="{ backgroundColor: cardInfo && cardInfo.ui_cardcolor ? cardInfo.ui_cardcolor : '#D6BF8E' }">
		    <div class="usercard-head-box">
		        <div class="usercard-head">
		          <img :src="cardInfo.ui.headimg">
		        </div>
		        <div>
		          <div class="usercard-name">{{cardInfo.ui.name}}</div>
		          <div class="usercard-company">
								<span v-if="cardInfo.ui && cardInfo.ui.company">{{cardInfo.ui.company}}</span>
							</div>
		        </div>
		    </div>
		    <div class="usercard-nav-box">
		      <div class="usercard-nav" v-for="(item,index) in newNavData" :key="index" @click="clickItem(item)">
					  <img class="nav-icon" v-if="isDarker" :src="item.ico_darker">
		        <img class="nav-icon" v-else :src="item.ico_light">
		        <label>{{item.name}}</label>
		      </div>
		    </div>
		  </div>
		</div>
    -->
		<!--  精简名片   -->
    <!--
		<div v-if="cardInfo.ui_cardtype == 2">
			<div class="usercard-container-small-fixed">
				<div v-bind:class="[isDarker ? 'usercard-container-small-n darker' : 'usercard-container-small-n light' ]" v-bind:style="{ backgroundColor: cardInfo && cardInfo.ui_cardcolor ? cardInfo.ui_cardcolor : '#D6BF8E' }">
					<div class="usercard-head-box">
						<div class="usercard-head">
							<img :src="cardInfo.ui.headimg">
						</div>
						<div class="usercard-middle-box">
							<div class="usercard-name">{{cardInfo.ui.name}}</div>
							<div class="usercard-company">{{cardInfo.ui.company ? cardInfo.ui.company : ''}}</div>
						</div>
						<div class="usercard-right-box">
							<div class="usercard-nav" v-for="(item,index) in newNavData" :key="index" @click="clickItem(item)">
								<img class="nav-icon" v-if="isDarker" :src="item.ico_darker">
								<img class="nav-icon" v-else :src="item.ico_light">
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="usercard-container-small-height"></div>
		</div>
    -->
		<!--  名片编辑   -->
    <!--
		<div class="usercard-edit-container" v-if="isMyCard">
		  <div class="usercard-edit-box">
		    <div @click="handleCardtype(1)" v-bind:class="[ cardInfo && cardInfo.ui_cardtype == 1 ? 'usercard-edit-item usercard-edit-item-cur' : 'usercard-edit-item']">标准名片</div>
		    <div @click="handleCardtype(2)" v-bind:class="[ cardInfo && cardInfo.ui_cardtype == 2 ? 'usercard-edit-item usercard-edit-item-cur' : 'usercard-edit-item']">精简悬浮</div>
		    <div @click="handleCardtype(3)" v-bind:class="[ cardInfo && cardInfo.ui_cardtype == 3 ? 'usercard-edit-item usercard-edit-item-cur' : 'usercard-edit-item']">隐藏</div>
		    <div class="usercard-edit-item" @click="handleEdit">名片设置</div>
		  </div>
		  <div class="usercard-edit-tips">
		    <div class="usercard-tips-line"></div>
		    <div class="usercard-tips-text">上方按钮分享后不显示</div>
		    <div class="usercard-tips-line"></div>
		  </div>
		</div> 
    -->
		<!--  企微海报   -->
		<vue_showimg v-if="isShowImg" v-bind:img_url="showImgUrl" v-bind:is_show_tips="true" v-bind:tips="'提示：长按识别二维码可添加企业微信'" v-on:close="closeShowImg"></vue_showimg>
  `,
  data() {
    return {
      isShowUserCard: false,
      newNavData: [
        {
          name: "电话",
          click: "clickCall",
          ico_light: "https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/light-phone.png",
          ico: "https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/phone-v2.png"
        },
        {
          name: "咨询",
          click: "clickChat",
          ico_light: "https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/light-msg.png",
          ico: "https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/msg-v2.png"
        },
        {
          name: "微信",
          click: "clickWx",
          ico_light: "https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/light-wx.png",
          ico: "https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/wx.png"
        },
        {
          name: "分享",
          click: "clickShare",
          ico_light: "https://assets.rurushishi.com/yq-rs-h5/t1/new-usercard/light-share.png",
          ico: "https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/share-v2.png"
        },
      ],
      btnChageMyTxt: "", //卡片按钮，两种模式：1、编辑 2、换成我的
      isShowHdkShare: false, //是否显示分享
      isShowShareGuide: false, //是否显示网页分享
      isShowImg: false,
      showImgUrl: "",
      isMyCard: false, //是我自己的名片。展示隐藏 展示操作按钮。
      isShowAni: false,
      isHideAni: false,
      // mapStatemapStatemapState
      isInMiniProgram: false,
      isShowMyCard: true,
      isShowGuide: true,
      cardInfo: null,
      userIntegralInfo: null,
      uiVersion: null, // 是否开启新UI 1 开启新UI
      qwQrCodeUrl: "", //企微二维码
      qwQrCodePoster: "", //企微海报
      cardConfig: {
        bgcolor: "#D6BF8E",
        cardtype: 1,
        downshow: 1,
      }
    };
  },
  computed: {
    isDarker() {
      if (this.cardInfo?.ui_cardcolor == "#D6BF8E" || this.cardInfo?.ui_cardcolor == "#D7D7D8") {
        return true;
      } else {
        return false;
      }
    },
    roleName() {
      let name = '';
      if (this.cardInfo.ui_position) {
        name = this.cardInfo.ui_position
      } else if (this.my_all_info.userIntegralInfo?.userInfo?.role?.length) {
        let roleid = this.my_all_info.userIntegralInfo.userInfo.role[0].roleid
        let myMap = new Map();
        myMap.set(2011, "销售顾问");
        myMap.set(2012, "案场经理");
        myMap.set(2015, "案场管理员");
        name = myMap.get(roleid) || '销售顾问'
      }
      return name
    },
    company() {
      return this.cardInfo.ui_company || this.cardInfo.projectname
    },
  },
  watch: {
    my_all_info: {
      handler(n) {
        if (n) {
          this.cardInfo = n.fansInfo;
          if (!this.cardInfo?.ui_cardtype) { // 默认类型
            this.cardInfo.ui_cardtype = 1
          }
          if (!this.cardInfo?.ui_cardcolor) { // 默认颜色
            this.cardInfo.ui_cardcolor = '#D6BF8E'
          }
        }
      },
      deep: true
    }
  },
  methods: {
    // 编辑或换成我的
    clickChangeMy() {
      var that = this;
      if (this.btnChageMyTxt == "编辑") {
        // 新版UI员工编辑
        const update = this.updateNewUiList();
        if (update || this.uiVersion == 1) {
          location.href = `${location.protocol}//${location.host}/marketies/${wj.browser.versions.wxwork ? 'qwdesk' : 'desk'}/pages/crm/sale-employee-modeify`;
        } else {
          location.href = location.protocol + "//" + location.host + "/marketies/rc/rs-desk-modifyInfo.html";
        }
      } else if (this.btnChageMyTxt == "换成我的") {
        this.$emit("change-is-me", function (cardInfo) {
          myTemp.rscuid = myTemp.openid;
          that.cardInfo = cardInfo;
          that.setCallAndChat();

          wj.getismp((ismp) => {
            if (ismp) {
              // var shareLink = `${location.protocol}//${location.host}/h5/t1.html?id=${myPageData.PageId}`;
              // if (myTemp.psn) {
              //   shareLink += "&psn=" + myTemp.psn;
              // }
              // shareLink += "&refereeopenid=" + myTemp.openid;
              // shareLink += "&rscuid=" + myTemp.openid;
              // 获取当前连接的参数
              let newUrlParam = wj.getParamFromUrl(location.href);
              // 去掉当前连接的参数j
              if (newUrlParam.j) {
                delete newUrlParam.j;
              }
              // 新增或替换refereeopenid、rscuid为 myTemp.openid
              newUrlParam.refereeopenid = myTemp.openid;
              newUrlParam.rscuid = myTemp.openid;
              // 把参数合并到当前连接
              let newUrl = wj.addUrlParamFromObj(wj.getUrlRemoveParams(location.href), newUrlParam);
              wj.mp.red(`/pages/webview/common/common?url=${encodeURIComponent(newUrl)}`);
            }
          });
        });
      }
    },
    clickItem(item) {
      this[item.click]();
    },
    // 电话
    clickCall() {
      AddCount(1);
      location.href = "tel:" + this.cardInfo.ui.mobile;
    },
    // 聊天
    clickChat() {
      // 去除点击咨询按钮时的统计
      // AddCount(13);
      // var tmpInterval = setInterval(function () {
      //   if (myTemp.consultingLink) {
      //     var url = myTemp.consultingLink;
      //     if (url.indexOf("chat_room.html") > -1 || url.indexOf("yqim/chat") > -1 || url.indexOf("sale-fans-interaction" > -1)) {
      //       if (myTemp.refereeopenid) {
      //         url += "&refereeopenid=" + myTemp.refereeopenid;
      //       }
      //     } else if (url.indexOf("cus-service.html") > -1) {
      //       // 客服服务已经添加过 refereeopenid 了
      //     }
      //     if (myTemp.rscuid) {
      //       url += "&rscuid=" + myTemp.rscuid;
      //     }
      //     // 在线售楼中心
      //     if (location.href.indexOf("&t9id=") > -1) {
      //       url += "&entry=zxslzx";
      //       url += "&t9id=" + wj.qs("t9id");
      //       url += "&t9psn=" + wj.qs("t9psn");
      //     }
      //     location.href = url;
      //     clearInterval(tmpInterval);
      //   }
      // }, 100)
      let url = myTemp.consultingLink;
      // 在线售楼中心
      if (myTemp.entry == "zxslzx" && myTemp.t9id && myTemp.t9psn) {
        url = wj.addUrlParamFromObj(url, {
          entry: "zxslzx",
          t9id: myTemp.t9id,
          t9psn: myTemp.t9psn,
        });
      }
      // 打开的不是企微客服链接的时候加带qwQrCodeUrl
      if (url.indexOf('work.weixin.qq.com') < 0) {
        if (myTemp.qwQrCodeUrl) {
          url = wj.addUrlParamFromObj(url, {
            qwQrCodeUrl: encodeURIComponent(myTemp.qwQrCodeUrl),
          });
        }
      }
      location.href = url;
    },
    // 微信 isFromCreated 为真的时候只是提前调用下但不弹框
    clickWx(isFromCreated) {
      if (!this.cardInfo) return new Promise((resolve, reject) => { resolve() });
      return new Promise((resolve, reject) => {
        if (this.qwQrCodeUrl) {
          resolve();
        } else {
          comreq
            .getExtUserIdByOpenid({
              openid: this.cardInfo.openid,
              accountType: "qywx",
              projectid: this.cardInfo.projectid || myPageData.Pid
            })
            .then((res) => {
              if (res.data && (res.data.userid || res.data.account) && res.data.accountOrgid) {
                myTemp.cardUserExtInfo = res.data;
                comreq
                  .getCorpUserCard({
                    corpId: res.data.accountOrgid,
                    appMark: window.myTemp.appMark,
                    type: 1,
                    scene: 2,
                    style: 1,
                    user: [res.data.userid || res.data.account],
                    businessData: {
                      sceneCode: "marketing_content",
                    },
                    projectId: this.cardInfo.projectid || myPageData.Pid,
                  })
                  .then((res1) => {
                    if (res1.data && res1.data.qr_code) {
                      myTemp.qwQrCodeUrl = res1.data.qr_code;
                      $(".qrcodeimg").attr("src", res1.data.qr_code);
                      comreq.base64(res1.data.qr_code).then((resImgUrl) => {
                        this.qwQrCodeUrl = resImgUrl;
                        resolve();
                      });
                    } else {
                      resolve();
                    }
                  });
              } else {
                resolve();
              }
            });
        }
      }).then(() => {
        if (this.qwQrCodeUrl) {
          this.newNavData = this.newNavData.map((item) => {
            if (item.click == "clickWx") {
              item.name = "企微";
              item.ico = "https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/qw-v2.png";
            }
            return item;
          });
          this.createQwQrCodePoster(isFromCreated);
          // 如果有企微且配置的企微的开关打开了就展示
          if (myPageData.Other && myPageData.Other.funcs && myPageData.Other.funcs.length > 0) {
            myPageData.Other.funcs.forEach((item) => {
              if (myTemp.bottomBtnCount < 5) {
                let isAdd = false;
                if (item.isvalid == 1) {
                  if (item.funcType == "qywx" && item.funcName) {
                    $(".btn_wxwork").css("display", "block");
                    isAdd = true;
                  }
                  if (isAdd) {
                    myTemp.bottomBtnCount++;
                  }
                }
              }
            });
          }
        } else if (this.cardInfo.wxqr && !isFromCreated) {
          $(".wx-qrcode .text").html("扫码，添加" + this.cardInfo.ui.name + "的微信！");
          $(".wx-qrcode .qr").attr("src", this.cardInfo.wxqr);
          $(".wx-qrcode .tips").html("扫码添加微信,了解更多信息");
          $(".wx-qrcode").removeClass("hide");
        } else if (this.cardInfo.ui_weixin && !isFromCreated) {
          alert(`我的微信号是：${this.cardInfo.ui_weixin}`);
        } else if (!isFromCreated) {
          alert("亲，您可以用电话联系我");
        }
      });
    },
    getMaxYData(cvsImgData) {
      let item = null;
      for (let index = 0; index < cvsImgData.length; index++) {
        if (index < cvsImgData.length - 1) {
          if (cvsImgData[index].y < cvsImgData[index + 1].y) {
            item = cvsImgData[index + 1];
          } else {
            item = cvsImgData[index];
          }
        }
      }
      return item;
    },
    createQwQrCodePoster(isFromCreated) {
      if (this.qwQrCodePoster) {
        this.showImgUrl = this.qwQrCodePoster;
        this.isShowImg = true;
        wj.addForbidSlide();
        return;
      }
      let bgWidth = 293;
      let bgHeight = 0; //根据文字高度动态计算
      let sharpness = 2;
      let labelX = 30;
      let baseY = 490;
      let cvsImgData = [
        // 顶部背景图
        {
          type: "img",
          zIndex: 2,
          x: 0,
          y: 0,
          width: bgWidth * sharpness,
          height: 293 * sharpness,
          content: "https://assets.rurushishi.com/yq-rs-h5/qwqrcode_bg4.png",
        },
        // 请加我的企微微信
        {
          type: "text",
          zIndex: 2,
          x: 62 * sharpness,
          y: 27 * sharpness,
          content: '请加我的企业微信',
          fontSize: `normal 600 ${21 * sharpness}px / ${24 * sharpness}px PingFang SC`,
          color: "#ffffff",
        },
        // 二维码
        {
          type: "img",
          shape: "",
          zIndex: 2,
          x: 66 * sharpness,
          y: 72 * sharpness,
          width: 160 * sharpness,
          height: 160 * sharpness,
          content: this.qwQrCodeUrl,
        },

        {
          type: "text",
          zIndex: 2,
          x: labelX * sharpness,
          y: baseY * sharpness,
          content: this.cardInfo.name,
          fontSize: `${30 * sharpness}px 微软雅黑`,
          color: "#333333",
        }
      ];
      // 公司
      let companyW = wj.getStrBlen(this.company) * 7;
      cvsImgData.push({
        type: "text",
        zIndex: 2,
        x: ((bgWidth - companyW) / 2) * sharpness,
        y: 257 * sharpness,
        content: this.company,
        fontSize: `normal ${14 * sharpness}px / ${16 * sharpness}px PingFang SC`,
        color: "#ffffff",
      })
      // 公司左边的线条
      cvsImgData.push({
        type: "img",
        shape: "",
        zIndex: 2,
        x: ((bgWidth - companyW) / 2 - 50 - 10) * sharpness,
        y: 264 * sharpness,
        width: 50 * sharpness,
        height: 2 * sharpness,
        content: 'https://assets.rurushishi.com/yq-rs-h5/line.png',
      })

      // 公司右边的线条
      cvsImgData.push({
        type: "img",
        shape: "",
        zIndex: 2,
        x: ((bgWidth - companyW) / 2 + 50 + 10) * sharpness,
        y: 264 * sharpness,
        width: 50 * sharpness,
        height: 2 * sharpness,
        content: 'https://assets.rurushishi.com/yq-rs-h5/line.png',
      })

      // 姓名
      let name = this.cardInfo.ui.name;
      if (name.length > 7) {
        name = name.substring(0, 7);
      }
      let nameW = wj.getStrBlen(this.cardInfo.ui.name) * 8;
      cvsImgData.push({
        type: "text",
        zIndex: 2,
        x: 31 * sharpness,
        y: (293 + 17) * sharpness,
        content: name,
        fontSize: `normal 600 ${16 * sharpness}px / ${16 * sharpness}px PingFang SC`,
        color: "#262626",
      })

      // 手机号
      cvsImgData.push({
        type: "text",
        zIndex: 2,
        x: (31 + nameW + 15) * sharpness,
        y: (293 + 17) * sharpness,
        content: this.cardInfo.ui.mobile,
        fontSize: `normal 600 ${16 * sharpness}px / ${16 * sharpness}px PingFang SC`,
        color: "#262626",
      })

      // 引号
      cvsImgData.push({
        type: "img",
        shape: "",
        zIndex: 2,
        x: 31 * sharpness,
        y: (293 + 42) * sharpness,
        width: 20 * sharpness,
        height: 20 * sharpness,
        content: 'https://assets.rurushishi.com/yq-rs-h5/t1/usercard_light/quotation-marks.png',
      })

      // 个人简介
      if (this.cardInfo.ui_personalprofile) {
        let tmpStrList = [];
        let tmpStrListIndex = 0;
        let title = this.cardInfo.ui_personalprofile;
        // title = "一二三四五六七八九十一";
        // title = "一二三四五六七八九十一二三四五六七八九十";
        // title =
        // "一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十一二三四五六七八九十";
        for (let index = 0; index < title.length; index++) {
          if (tmpStrListIndex == 0 || tmpStrListIndex >= 32 * tmpStrList.length) {
            tmpStrList.push(title[index]);
          } else {
            tmpStrList[tmpStrList.length - 1] += title[index];
          }
          // 处理中英文占的长度
          tmpStrListIndex += wj.getStrBlen(title[index]);
        }
        let stringYStartValue = 293 + 69;
        // 最多展示三行
        // if (tmpStrList.length > 3) {
        //   tmpStrList = tmpStrList.slice(0, 3);
        // }
        let stringX = 31;
        for (let index = 0; index < tmpStrList.length; index++) {
          let stringY = 0;
          if (tmpStrList.length == 1) {
            stringY = stringYStartValue;
          } else {
            stringY = stringYStartValue + 20 * index;
          }
          let item = {
            type: "text",
            zIndex: 4,
            fontSize: `normal normal ${14 * sharpness}px / ${20 * sharpness}px PingFang SC`,
            x: stringX * sharpness,
            y: stringY * sharpness,
            content: tmpStrList[index],
            color: "#8C8C8C",
          };
          cvsImgData.push(item);
        }
      }

      // 企业微信logo
      let maxYItem = this.getMaxYData(cvsImgData);
      cvsImgData.push({
        type: "img",
        shape: "",
        zIndex: 2,
        x: 96 * sharpness,
        y: maxYItem.y + (20 + 10) * sharpness,// 上面文字的最大y+行高+间距
        width: 100 * sharpness,
        height: 34 * sharpness,
        content: 'https://assets.rurushishi.com/yq-rs-h5/logo_qywx.png',
      })
      maxYItem = this.getMaxYData(cvsImgData);
      bgHeight = maxYItem.y + (34 + 20) * sharpness;//最大y+企业微信logo高度+底部间距
      const cvsimg = new Canvastoimg({
        width: bgWidth * sharpness, //画布宽度
        height: bgHeight, //画布高度
        color: "#ffffff", //画布背景色
        data: cvsImgData,
      });
      cvsimg.down().then((canvas) => {
        /* 获取到的是canvas对象 */
        this.qwQrCodePoster = canvas.toDataURL("image/jpg");
        if (!isFromCreated) {
          this.showImgUrl = this.qwQrCodePoster;
          this.isShowImg = true;
          wj.addForbidSlide();
        }
      });
    },
    // 分享
    clickShare() {
      this.$emit('show-share')
    },
    // 隐藏卡片
    clickCardHide() {
      this.isShowAni = false;
      this.isHideAni = true;
      var that = this;
      // setTimeout(function () {
      //   that.isShowMyCard = false;
      // }, 500)

      that.isShowMyCard = false;
      myVue.$refs.usercard4.isShowUserCard = false;
      myVue.$refs.usercard4.isShowMyCard = false;
      comreq.updatePageUserSetting(null, 1);
    },
    // 展示卡片
    clickCardShow() {
      this.isHideAni = false;
      this.isShowAni = true;
      var that = this;
      // setTimeout(function () {
      //   that.isShowMyCard = true;
      // }, 500)
      that.isShowMyCard = true;
      myVue.$refs.usercard4.isShowUserCard = true;
      myVue.$refs.usercard4.isShowMyCard = true;
      comreq.updatePageUserSetting(null, 0);
    },
    initCardShowHide() {
      console.log(111, "myPageData.Other.PageUserSetting", myPageData.Other.PageUserSetting);
      var that = this;
      if (myPageData.Other.PageUserSetting) {
        if (myPageData.Other.PageUserSetting.cardhidden == 0) {
          that.isShowMyCard = true;
        } else if (myPageData.Other.PageUserSetting.cardhidden == 1) {
          that.isShowMyCard = false;
        }
      } else {
        that.isShowMyCard = true;
      }
    },
    setCallAndChat() {
      var that = this;
      if (myTemp.rscuid || myTemp.agentcuid || (this.my_all_info.userIntegralInfo && (this.my_all_info.userIntegralInfo.isSale || this.my_all_info.userIntegralInfo.isAgentType4))) {
        this.isShowUserCard = true;
      }
      if (window.cfg.subdomian == "tyry") {
        this.isShowUserCard = false;
      }

      if (myTemp.rscuid) {
        if (this.my_all_info.userIntegralInfo && this.my_all_info.userIntegralInfo.isSale) {
          if (myTemp.rscuid != myTemp.openid) {
            // 隐藏换成我的
            this.btnChageMyTxt = "";
            // this.btnChageMyTxt = "换成我的";
          } else {
            this.btnChageMyTxt = "";
            // this.btnChageMyTxt = "编辑";
            that.isMyCard = true;
          }
        }
      }
      if (this.my_all_info.userIntegralInfo && this.my_all_info.userIntegralInfo.isSale) {
        this.btnChageMyTxt = "";
        // this.btnChageMyTxt = "编辑";
        that.isMyCard = true;
        myTemp.rscuid = myTemp.openid;
      }
      // 致电和聊天换成这个
      if (that.cardInfo && typeof that.cardInfo == "object") {
        if (that.cardInfo.ui && wj.isMobileNumber(that.cardInfo.ui.mobile)) {
          $(".btn_zd_a").attr("href", "tel:" + that.cardInfo.ui.mobile);
        } else {
          $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
        }
        // if (myTemp.openid != that.cardInfo.openid) {
        //   if (location.host.indexOf('qmyx') > -1) {
        //     myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/desk/pages/fans/sale-fans-interaction?receiveropenid=${that.cardInfo.openid}&projectid=${myPageData.Pid}`;
        //   } else {
        //     myTemp.consultingLink = `${location.protocol}//${location.host}/newcode/src/chat_room.html?openid=${myTemp.openid}&passport=${myTemp.passport}&receiveropenid=${that.cardInfo.openid}&nickname=&pageid=${myPageData.PageId}&projectid=${myPageData.Pid}`;
        //   }
        // }
      }
      if (this.isMyCard) {
        $(".share-icon").removeClass('hide');
        $(".share-icon").on("click", function (e) {
          that.$emit('show-share');
          return false;
        })
      }
    },
    // 升级新UI跳转员工修改页面
    updateNewUiList() {
      const newDomain = ["yqjisu", "sdydfdck", "qmyx", "rushi"];
      return newDomain.filter((item) => location.host.indexOf(item) > -1).length > 0;
    },
    checkUiVersion() {
      comreq.getUiVersion().then((res) => {
        console.log(res);
        this.uiVersion = res.data;
      });
    },
    closeShowImg() {
      this.isShowImg = false;
      wj.removeForbidSlide();
    },
    handleCardtype(type) {
      comreq.apiUpdateMyFans(this.cardInfo.openid, type).then((res) => {
        console.log(res);
        if (res.code == 0) {
          // location.reload()
          myVue.init()
        } else {
          alert(res.msg);
        }
      });
    },
    showFootCard() {
      this.$emit("set-footercard", {
        newNavData: this.newNavData,
        cardConfig: this.cardConfig,
        cardInfo: this.cardInfo,
      });
    },
    handleEdit() {
      if (!this.isMyCard) return;
      console.log("edit");
      let subdomain = location.hostname.split('.')[0]
      if (subdomain == 'localhost') {
        subdomain = 'qmyx'
      }
      let url = `http://${subdomain}.rushinews.com/marketies/${wj.browser.versions.wxwork ? 'qwdesk' : 'desk'}/pages/crm/sale-employee-modeify?backurl=${encodeURIComponent(location.href)}`
      location.href = url
    },
    initAgreementTips() {
      // 隐私协议
      comreq.getPrivacyPolicyBrowseLog({
        projectId: myPageData.Pid
      }).then(res => {
        // 未展示过
        if (!res?.data) {
          $(".agreement_tips").removeClass("hide");
          // 有名片
          if (this.isMyCard && !wj.browser.versions.wxwork) {
            $(".agreement_tips_desk").removeClass("hide");
          }
          // 进行展示并且5秒后隐藏
          $(".agreement_tips_txt").removeClass('hide');
          $(".btnShowAgreement").on("click", function () {
            $(".agreement_box").removeClass("hide");
          })
          $(".agreement_content .close").on("click", function () {
            document.documentElement.scrollTop = 0;
            $(".agreement_box").addClass("hide");
          })
          setTimeout(() => {
            if (this.isShowUserCard && !wj.browser.versions.wxwork) {
              $(".agreement_tips_txt").addClass('hide');
              $(".agreement_tips").css('flex-direction', 'row-reverse');
            } else {
              $(".agreement_tips").addClass("hide");
            }
            comreq.savePrivacyPolicyBrowseLog({
              projectId: myPageData.Pid,
              openid: myTemp.openid,
              pageId: myPageData.PageId
            })
          }, 1000 * 5);
        } else {
          // 已展示过
          // 有名片
          if (this.isMyCard && !wj.browser.versions.wxwork) {
            $(".agreement_tips").removeClass("hide");
            $(".agreement_tips").css('flex-direction', 'row-reverse');
            $(".agreement_tips_desk").removeClass("hide");
          }
        }
        if (this.isMyCard && !wj.browser.versions.wxwork) {
          $(".agreement_tips_desk").on('tap', function () {
            location.href = `${location.protocol}//${location.host}/marketies/desk/pages/index/sale`;
          })
          $(".image-text").css("margin-top", 0);
        }
      })
    }
  },
  created() {
    console.log("cardinfo333", JSON.parse(JSON.stringify(this.my_all_info)));
    console.log(111, "myPageData", myPageData);
    /**
     * 名片：有rscuid 或 是销售 》展示 名片信息
     *
     * 名片：有rscuid 且 是销售 且 rscuid不等于自己的openid =》名片信息 展示 换成我的
     * 名片：有rscuid 且 是销售 且 rscuid等于自己的openid =》名片信息 展示 编辑
     * 名片：没有rscuid 且是销售 名片信息 展示编辑
     * 名片：点击换成我的、更改cardInfo信息为自己的信息，初始化分享rscuid是自己的openid
     */

    this.cardInfo = this.my_all_info.fansInfo;
    if (!this.cardInfo?.ui_cardtype) { // 默认类型
      this.cardInfo = {
        ...this.cardInfo,
        ui_cardtype: 1
      }
      // this.cardInfo.ui_cardtype = 1
    }
    if (!this.cardInfo?.ui_cardcolor) { // 默认颜色
      this.cardInfo.ui_cardcolor = '#D6BF8E'
    }
    this.setCallAndChat();
    this.initAgreementTips();
    this.initCardShowHide();

    // 检查是否为新UI
    this.checkUiVersion();
    this.clickWx(true).then(() => {
      console.log("初始化名片完成")

      if (myTemp.qwkfInfo?.corpid && myTemp.qwkfInfo?.openKfid) {
        wj.handlerQwkf(myTemp?.cardUserExtInfo?.userid);
      }

      window.setContentSelf();
    })
    this.showFootCard()
    let that = this;
    $(".btn_wxwork").on("click", function () {
      that.clickWx();
    });
  },
});
